<template>
  <path
    d="M12 2.00024C8.13 2.00024 5 5.13024 5 9.00024C5 13.1702 9.42 18.9202 11.24 21.1102C11.64 21.5902 12.37 21.5902 12.77 21.1102C14.58 18.9202 19 13.1702 19 9.00024C19 5.13024 15.87 2.00024 12 2.00024ZM12 11.5002C10.62 11.5002 9.5 10.3802 9.5 9.00024C9.5 7.62024 10.62 6.50024 12 6.50024C13.38 6.50024 14.5 7.62024 14.5 9.00024C14.5 10.3802 13.38 11.5002 12 11.5002Z"
  />
</template>
